import { Suspense, lazy } from "react";
import { Hero } from "@/components/home/Hero";
import {
  buildRoofingContractorSchema,
  buildOrganizationSchema,
  buildWebSiteSchema,
} from "@/lib/schema";

const GoogleReviews = lazy(() =>
  import("@/components/home/GoogleReviews").then((m) => ({
    default: m.GoogleReviews,
  })),
);
const Features = lazy(() =>
  import("@/components/home/Features").then((m) => ({ default: m.Features })),
);
const AboutCompany = lazy(() =>
  import("@/components/home/AboutCompany").then((m) => ({
    default: m.AboutCompany,
  })),
);
const BrandMarquee = lazy(() =>
  import("@/components/home/BrandMarquee").then((m) => ({
    default: m.BrandMarquee,
  })),
);
const Process = lazy(() =>
  import("@/components/home/Process").then((m) => ({ default: m.Process })),
);
const RecentProjects = lazy(() =>
  import("@/components/home/RecentProjects").then((m) => ({
    default: m.RecentProjects,
  })),
);
const TrendingArticles = lazy(() =>
  import("@/components/home/TrendingArticles").then((m) => ({
    default: m.TrendingArticles,
  })),
);
const HomeFAQ = lazy(() =>
  import("@/components/home/HomeFAQ").then((m) => ({ default: m.HomeFAQ })),
);
const ComparisonTable = lazy(() =>
  import("@/components/home/ComparisonTable").then((m) => ({
    default: m.ComparisonTable,
  })),
);

const Index = () => {
  return (
    <>
      <main>
        <Hero />
        <Suspense fallback={<div className="min-h-[200px]" />}>
          <GoogleReviews />
          <Features />
          <AboutCompany />
          <BrandMarquee />
          <Process />
          <RecentProjects />
          <HomeFAQ />
          <ComparisonTable />
          <TrendingArticles />
        </Suspense>
      </main>
    </>
  );
};

export default Index;
